import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';
import { NotificationProvider } from './NotificationContext';
import { ProductProvider } from './ProductContext';
import { DamagedProductsProvider } from './DamagedProductsContext';
import { SalesHistoryProvider } from './SalesHistoryContext';
import { PrintingProvider } from './PrintingContext';
import { CashProvider } from './CashContext';
import { OtherServiceSalesProvider } from './OtherServiceSalesContext';
import { UsersProvider } from './UsersContext';

if (process.env.NODE_ENV === 'production') {
  // Hide debug/noise logs in production browser console.
  // This does not replace real security controls on server/API.
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // Prevent accidental number changes from mouse wheel while typing.
  document.addEventListener(
    'wheel',
    (e) => {
      const el = e.target;
      if (
        el instanceof HTMLInputElement &&
        el.type === 'number' &&
        document.activeElement === el
      ) {
        e.preventDefault();
      }
    },
    { passive: false }
  );

  // Block scientific-notation / sign keys that often cause confusing "stuck" values.
  document.addEventListener('keydown', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement) || el.type !== 'number') return;
    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <LanguageProvider>
      <NotificationProvider>

        <ProductProvider>
          <DamagedProductsProvider>
            <SalesHistoryProvider>
              <PrintingProvider>
                <CashProvider>
                  <OtherServiceSalesProvider>
                    <UsersProvider>
                      <App />
                    </UsersProvider>
                  </OtherServiceSalesProvider>
                </CashProvider>
              </PrintingProvider>
            </SalesHistoryProvider>
          </DamagedProductsProvider>
        </ProductProvider>
      </NotificationProvider>
      </LanguageProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
